export const isNullOrUndefined = function(value) {
    return value === null || value === undefined;
};

export const arrayHasValues = function(array) {
    return !isNullOrUndefined(array) && array.length > 0;
};

export const isValidEmail = function(value) {
    if (isNullOrUndefined(value) || value === "") return false;
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
};